export default __webpack_public_path__ + "static/media/todomvc.9cf2c177.svg";